import { render, staticRenderFns } from "./wrongQuestions.vue?vue&type=template&id=3bc4018c&scoped=true&"
import script from "./wrongQuestions.vue?vue&type=script&lang=js&"
export * from "./wrongQuestions.vue?vue&type=script&lang=js&"
import style0 from "./wrongQuestions.vue?vue&type=style&index=0&id=3bc4018c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4018c",
  null
  
)

export default component.exports